'use strict';

import { setOnLoadBeacon, setOnViewBeacon, setOnWishlistBeacon } from './criteoSetupBeacons';

const swatchSelector = require('../components/swatchSelector.js');

const config = {
    template: '',
    selectedUrl: '',
    mapping: [],
    allGroupedPlaceholder: {},
    affectedSlider: []
};

const tiles = {
    html: []
};

function checkPldOrPdp() {
    let page;
    if (document.querySelector('.js-page-plp:not(.js-page-search)')) page = 'plp';
    if (document.querySelector('.js-page-pdp')) page = 'pdp';

    return page;
}

/**
 * Divides all placeholders into their respective groups
 * @param {NodeListOf<HTMLElement>} allPlaceholder All placeholders to be split
 */
function groupedPlaceholder(allPlaceholder) {
    allPlaceholder.forEach(placeholder => {
        const type = placeholder.getAttribute('data-criteo-container');

        if (config.allGroupedPlaceholder[type]) {
            config.allGroupedPlaceholder[type].push(placeholder);
        }
    });
}

/**
 * Doublet management in recommendation slider
 * setGroupedProductSkuList filters whether SKUs are already present in the slider and removes them.
 * @param {Array} sliderProductSkuList Array with SKUs that are loaded in the slider without criteo 
 * @param {Array} groupedProductSKUs Array with grouped SKUs coming from criteo 
 * @return {Array} onlyInGroupedProductSkuList Array with filtered and grouped SKUs
 */
function doubletManagement(sliderProductSkuList, groupedProductSKUs) {


    // Unique values ​​of both arrays (Set automatically avoids duplicates within an array)
    const setSliderProductSkuList = new Set(sliderProductSkuList);
    const setGroupedProductSkuList = new Set(groupedProductSKUs);

    const onlyInGroupedProductSkuList = [...setGroupedProductSkuList].filter(x => !setSliderProductSkuList.has(x));

    return onlyInGroupedProductSkuList;
}

/**
 * Requests the backend with a list of SKUs and gets a sting back with the HTML source code of tiles.
 * @param {Array} skuArray Array with SKUs that are loaded in the slider without criteo 
 * @return {string} res HTML Tiles source code as string
 */
function fetchCriteoProductsFromStore(skuArray) {
    var url = `${window.spsDataLayer.endpoints.endpointTileCriteoSkuList}${encodeURIComponent(skuArray.join(','))}`

    return fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(function (res) {
        if (!res.ok) throw new Error('Netzwerk-Fehler');
        return res.text();
    });
}

/**
 * Split the HTML string Tiles source code into individual HTML Product Tiles elements 
 * and store them in the tiles.html array.
 * @param {string} htmlString HTML source code of tiles
 */
const splitProductsToTiles = (htmlString) => {
      config.template.innerHTML = htmlString;
      const fragment = config.template.content;

      tiles.html = fragment.querySelectorAll('div.product.cc-product');
}

/**
 * Replaces placeholders with tiles and replaces some points in tiles.
 * @param {string} placement response of criteo for a part of sponsored products
 */
const replacePlaceholder = (placement) => {
    config.mapping.forEach(({ placementKey, groupKey }) => {

        const placementSection    = placement[placementKey]?.[0];
        const products            = placement[placementKey]?.[0]?.products;
        const placeholders        = config.allGroupedPlaceholder?.[groupKey];
        let groupedProductSKUs    = [];

        if (!products || !placeholders) return;

        products.forEach(product => {
            groupedProductSKUs.push(product.ParentSKU);
        });

        if (checkPldOrPdp() === 'plp') {
            const necessaryProductsPerRow = window.isMobile ? 2 : 4;

            if (!(groupedProductSKUs?.length >= necessaryProductsPerRow)) {
              removePlaceholder(groupKey);
              return;
            }

        } else if (checkPldOrPdp() === 'pdp') {
            const sliderProductSkuList = placeholders[0]?.closest('[data-slider-skus]')?.getAttribute('data-slider-skus');

            if (sliderProductSkuList) {
                groupedProductSKUs = doubletManagement(sliderProductSkuList, groupedProductSKUs);
            }
        }

        fetchCriteoProductsFromStore(groupedProductSKUs).then(function (htmlTiles) {

            splitProductsToTiles(htmlTiles.trim());

            placeholders.forEach((placeholderEl, index) => {

                let html = tiles.html[index]; 

                // try to match product by SKU (ParentSKU) to the generated tile's data-pid
                const tilePid = tiles.html[index]?.dataset?.pid;
                let currentProduct = tilePid
                    ? products.find(p => String(p.ParentSKU) === String(tilePid)) || products[index]
                    : products[index];

                if (!html) {
                     removePlaceholderElement(placeholderEl)
                     return;
                }
                    

                html.querySelector('.js-tile-url').setAttribute('href', currentProduct.ProductPage);
                html.querySelector('.cc-tile__body a').setAttribute('href', currentProduct.ProductPage);

                if (checkPldOrPdp() === 'plp') {
                    if (tiles.html[index].dataset.pid !== "null" && tiles.html[index].dataset.pid !== null 
                    && tiles.html[index] != null

                    ) {
                        const wrapperElement = document.createElement('article');
                        wrapperElement.classList.add("cc-plp__item");
                        wrapperElement.appendChild(tiles.html[index]);

                        placeholderEl.replaceWith(wrapperElement);
                    } else {
                        removePlaceholderElement(placeholderEl);
                    }
                } else if (checkPldOrPdp() === 'pdp') {
                    if (tiles.html[index].dataset.pid !== "null" && tiles.html[index].dataset.pid !== null ) {
                        placeholderEl.replaceWith(tiles.html[index]);
                    } else {
                        removePlaceholderElement(placeholderEl);
                    }
                }

                const insertedElement = document.querySelector(
                    `[data-pid="${currentProduct.ParentSKU}"]`
                );

                if (!insertedElement) {
                    removePlaceholderElement(placeholderEl)
                    return;
                }

                setOnLoadBeacon(currentProduct.OnLoadBeacon);
                setOnViewBeacon({
                    target: insertedElement,
                    url: currentProduct.OnViewBeacon,
                });
                setOnWishlistBeacon({
                    target: insertedElement,
                    url: currentProduct.OnWishlistBeacon,
                }); 

                if (index === 0) {
                  setOnLoadBeacon(placementSection.OnLoadBeacon);
                  setOnViewBeacon({
                      target: insertedElement,
                      url: placementSection.OnViewBeacon,
                  });
                }
            });

            swatchSelector.initializeClass();

        });
    });
};

/**
 * Add the relevant sliders to the config for later use and prevent duplicate sliders.
 * @param {HTMLElement} slider affected slider
 */
const addAffectedSlidersToConfig = (slider) => {
    if (!config.affectedSlider.includes(slider)) {
        config.affectedSlider.push(slider);
    }
}

/**
 * Deletes placeholders using the slick slider feature to resolve NOA-4717. The index changes after each deletion.
 * @param {HTMLElement} el placeholder
 */
const removePlaceholderFromSlider = (el) => {
    const slider = el.closest('.js-slider');
    const parent = el.closest('.slick-track');
    const child = el.closest('.slick-slide');
    const slideIndex = Array.from(parent.children).findIndex(el => el === child);

    addAffectedSlidersToConfig(slider);
    
    $(slider).slick('slickRemove', slideIndex);
}

/**
 * Removes placeholders for a specific row or all placeholders.
 * @param {string} row or the groupKey of tiles
 */
const removePlaceholder = (row) => {
    const selector = (row) ? `[data-criteo-container="${row}"]` : '[data-criteo-container]';

    document.querySelectorAll(selector).forEach(placeholderElement => {
        if (placeholderElement.closest('.slick-slide')) {
            removePlaceholderFromSlider(placeholderElement);
        } else {
            placeholderElement.remove();
        }
    });

    config.affectedSlider.forEach(slider => {
        console.log('slider: ', slider);
        $(slider).slick('refresh');
    });
};

/**
 * Removes a single placeholder
 * @param {HTMLElement} placeholderElement
 */
const removePlaceholderElement = (placeholderElement) => {
    if (placeholderElement.closest('.slick-slide')) {
        removePlaceholderFromSlider(placeholderElement);
        config.affectedSlider.forEach(slider => {
            $(slider).slick('refresh');
        });
    } else {
        placeholderElement.remove();
    }
};

async function getCriteoSponsoredProducts() {
    try {
        if (config.spsDataLayerCriteo.mocked) {
            if (checkPldOrPdp() === 'plp') {
                config.selectedUrl = config.spsDataLayerCriteo.mockedUrlPLP;
            } else if (checkPldOrPdp() === 'pdp') {
                config.selectedUrl = config.spsDataLayerCriteo.mockedUrlPDP;
            }
        }
        if (checkPldOrPdp() === 'plp' && (config?.spsDataLayerCriteo?.plp?.parentItem?.split('|')?.length ?? 0) < (window.isMobile ? 2 : 4)){
            removePlaceholder(false);
            return;
        }

        const response = await fetch(config.selectedUrl);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        const placements = data.placements;
        
        if (placements && placements.length) {
            
            // remove all Placeholder without placements in the response.
             config.mapping.forEach(({ placementKey, groupKey }) => {
                if ((placements.find(p => p[placementKey])?.[placementKey]?.find(i => i)?.products?.length ?? 0) < 1) {
                    removePlaceholder(groupKey);
                 }
            });
            
            placements.forEach(placement => {
                replacePlaceholder(placement);
            });
        } else {
            removePlaceholder(false);
        }
        
    } catch (error) {
        config.allPlaceholder.forEach(element => {
            if (element instanceof HTMLElement) {
                element.classList.add('cc-placeholder--no-animation')
            }
        });
        return false;
    }
}

/**
 * Formats the filter tags in a format suitable for Criteo for the request to Criteo
 * @param {Array} filterArray 
 * @return {string} string with formatted filter criteria
 */
function formatFilterParameters(filterArray) {
    const filterTags = [];
    filterArray.forEach(filter => {
        filterTags.push(`(${filter.filterId},${filter.filterOperator},${filter.filterDisplayValue})`);
    });

    return filterTags.join(',');
}

function setupConf() {
    
    config.customerId = '';
    config.retailerVisitorId = '';
    
    if  (window.spsDataLayer.internal.visitorId && window.spsDataLayer.internal.visitorId !== '') {
        config.retailerVisitorId = window.CryptoJS.SHA256(window.spsDataLayer.internal.visitorId, 'criteo').toString(window.CryptoJS.enc.Base64);
    }
    
    if  (window.spsDataLayer.internal.customerId && window.spsDataLayer.internal.customerId !== '') {
        config.customerId = window.CryptoJS.SHA256(window.spsDataLayer.internal.customerId, 'criteo').toString(window.CryptoJS.enc.Base64);
    }

    config.template = document.createElement('template');
    config.allPlaceholder = document.querySelectorAll('[data-criteo-container]');

    if (checkPldOrPdp() === 'plp') {
        config.mapping = [
            { placementKey: 'viewCategory_large-TopInGrid',    groupKey: 'top' },
            { placementKey: 'viewCategory_large-MidInGrid',    groupKey: 'mid' },
            { placementKey: 'viewCategory_large-BottomInGrid', groupKey: 'bottom' },
        ];
        config.allGroupedPlaceholder = {
            top:    [],
            mid:    [],
            bottom: []
        };

            config.selectedUrl = `${config.spsDataLayerCriteo.endpoint}?criteo-partner-id=${config.spsDataLayerCriteo.partnerId}&environment=${config.spsDataLayerCriteo.environment}&retailer-visitor-id=${config.retailerVisitorId}&customer-id=${config.customerId}&page-id=viewCategory_large&event-type=viewCategory&page-number=${config.spsDataLayerCriteo.plp.pageNumber}&list-size=${config.spsDataLayerCriteo.plp.listSize}&category=${config.spsDataLayerCriteo.plp.category}&parent-item=${config.spsDataLayerCriteo.plp.parentItem}&filters=${config.spsDataLayerCriteo.plp.filters}`;

    } else if (checkPldOrPdp() === 'pdp') {
        config.mapping = [
            { placementKey: 'viewItemAPI-pdp_ad',    groupKey: 'pdp_ad' },
            { placementKey: 'viewItemAPI-pdp_ad_2',    groupKey: 'pdp_ad2' },
        ];

        config.allGroupedPlaceholder = {
            pdp_ad:  [],
            pdp_ad2: [],
        };
        config.selectedUrl = `${config.spsDataLayerCriteo.endpoint}?criteo-partner-id=${config.spsDataLayerCriteo.partnerId}&environment=${config.spsDataLayerCriteo.environment}&retailer-visitor-id=${config.retailerVisitorId}&customer-id=${config.customerId}&page-id=viewItemAPI&event-type=viewItem&parent-item=${config.spsDataLayerCriteo.pdp.parentItem}&price=${config.spsDataLayerCriteo.pdp.price}&availability=${config.spsDataLayerCriteo.pdp.availability}`;
    }

    groupedPlaceholder(config.allPlaceholder);

}

function initCriteo() {
    config.spsDataLayerCriteo = window?.spsDataLayer?.ThirdParty?.criteo;

    const isPromotionSearch = Boolean(new URLSearchParams(window.location.search).has('pmid') && document.querySelector('.js-page-plp')); 

    if (isPromotionSearch || document.querySelector('[data-usercentrics="Criteo Sponsored Products"]') || typeof config.spsDataLayerCriteo === 'undefined') {
        removePlaceholder(false);

        if (isPromotionSearch) {
            const filterBar = document.querySelector('.js-filterbar-observe');
            if (filterBar) {
                new MutationObserver(() => removePlaceholder(false))
                    .observe(filterBar, { childList: true });
            }
        }

        return;
    } 

    setupConf();
    getCriteoSponsoredProducts();

    if (checkPldOrPdp() === 'plp') {
        function onFilterBarChange(mutationsList) {
            setupConf();
            getCriteoSponsoredProducts();
        };

        const filterBar = document.querySelector('.js-filterbar-observe');
        if (filterBar) {
            const callback = (mutationsList, observer) => {
                onFilterBarChange(mutationsList);
            };

            const observer = new MutationObserver(callback);
            observer.observe(filterBar, {
                childList: true
            });
        }
    }
}

export function init() {
    if (state.ucCriteo === 'initCriteo') {
        initCriteo();
    }

    window.usercentrics = Object.assign(window.usercentrics || {}, {
        initCriteo,
    });
}